import API_Call_Handler from "@/api/API_Call_Handler";
import API_Calls_Utils from "@/api/API_Calls_Utils";
import { getBackendUrl } from "@/utils/util";

export default function API_Calls_Events() {
  const { apiCall } = API_Call_Handler();
  const backendUrl = getBackendUrl();
  const { queryParamsAndHeaders } = API_Calls_Utils();

  const createEvent = async (formData) => {
    const { headers } = await queryParamsAndHeaders({});

    return apiCall({
      url: `${backendUrl}/api/event/new`,
      method: "POST",
      headers,
      data: formData,
    });
  };

  const getEvents = async (affiliate, active_only) => {
    const { headers, queryString } = await queryParamsAndHeaders({
      affiliate,
      active_only,
    });
    return apiCall({
      url: `${backendUrl}/api/events/?${queryString}`,
      method: "GET",
      headers,
    });
  };

  const postEventStatus = async (event_id, data) => {
    const { headers, queryString } = await queryParamsAndHeaders({
      event_id,
    });

    return apiCall({
      url: `${backendUrl}/api/event/status?${queryString}`,
      method: "POST",
      headers,
      data,
    });
  };

  return {
    createEvent,
    getEvents,
    postEventStatus,
  };
}
